import React from 'react';
import {
  Container,
  Row,
  Card,
  Col,
  Button,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { useEffect } from 'react';
import { useState } from 'react';
import ActionRequestService from '../../services/action-request';
import { WidgetsOutlined, Add, ArrowBackIos } from '@material-ui/icons';
import ActionList from './List';
import Can from 'components/Can';
import { Link, useHistory } from 'react-router-dom';
import { useCompany, useProfile, useUser } from 'models';
import NavBar from 'components/NavBar';
import {
  useParams
} from "react-router-dom";

export default function () {
  const { fiscal_year } = useParams();
  const user = useUser()
  const profile = useProfile()
  const { company: currentCompany } = useCompany()

  //const [flow, setFlow] = useState(null);
  const [status, setStatus] = useState([]);
  const [countActions, setCountActions] = useState([]);

  const [flowSelected, setFlowSelected] = useState(1);
  //const [fiscalYear, setFiscalYear] = useState(getCurrentFiscalYear());

  const filtered = user.fiscal_years.filter(a => a.fiscal_year === fiscal_year)
  const fiscalYear = filtered.length > 0 ? filtered[0].id : user.fiscal_year.id

  //const fiscalYear = !!fiscal_year?user.fiscal_years.filter(a=>a.fiscal_year===fiscal_year)[0].id:user.fiscal_year.id
  const history = useHistory();

  useEffect(() => {
    getFlows();
    getActions();
  }, []);

  const getFlows = () => {
    let request = ActionRequestService.getFlow(4);
    request.then((data) => {
      let r = data.data.data;
      r.user_steps = [];
      if (user.profile.steps)
        user.profile.steps.forEach((step) => {
          if (r.id === step.flow_id) {
            r.user_steps[step.id] = step;
          }
        });
      setStatus(Object.values(r.action_status));
    });
  };

  const getProfile = () => {
    return user.profile
  };

  const getActions = (fiscal_year_id = null, company_id = null) => {
    var filter = {
      fiscal_year_id: fiscal_year_id ?? fiscalYear,
      __fund_type_id: 4,
      company_id: company_id ?? currentCompany ? currentCompany.id : null
    };

    ActionRequestService.amountByStatus({ params: { ...filter } }).then(
      (data) => {
        setCountActions(data.data.data);
      }
    );
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Período de bloqueio para solicitação de novas ações. A partir do dia
      primeiro do mês seguinte o sistema será reaberto para novas solicitações.
      Dúvidas consulte a seção de Perguntas e Respostas (FAQ).
    </Tooltip>
  );
  const getDay = () => {
    let a = new Date();
    return a.getDate();
  };

  // const changeFiscalYear = (id) => {
  //   const filter = {
  //     fiscal_year_id: id
  //   };
  //   if(currentCompany){
  //     filter.company_id = currentCompany
  //       ? currentCompany.id
  //       : user.currentCompany.id;

  //     let companies = ResalesRequestService.getGroupHeadquarter({
  //       params: { ...filter },
  //     });
  //     companies.then((data) => {
  //       let c = data.data.data;
  //       // setCompanyId(data.data.data.company_id)
  //       // setFiscalYear(id);
  //       getActions(parseInt(id), c.company_id);
  //     });
  //   }else{
  //     // setFiscalYear(id);
  //     getActions(parseInt(id))
  //   }
  // }

  // const getSizeNavItem = () => {
  //   let width = window.innerWidth;
  //   if(width <= 341){
  //     return {width:'51%'}
  //   }
  //   else if(width <= 441){
  //     return {width:'34%'}
  //   }
  //   else if(width <= 767){
  //     return {width:'26%'}
  //   }
  //   return {};
  // }
  return (
    <>
      <Container>
        <Row className="mt-4">
          <Button variant="link" className="link-back" onClick={() => history.goBack()}>
            <ArrowBackIos className="icon-title icon-back" />
            <h6 className="font-13 mt-3">Voltar</h6>
          </Button>
        </Row>
        <Row className="mt-4 d-flex align-items-end">
          <Col className="d-flex">
            <WidgetsOutlined className="icon-title" />
            <h5 className="title-dashboard">Fluxo de Inovação{!!fiscal_year?` - ${fiscal_year}`:""}</h5>
          </Col>
          {!!fiscal_year?(
            <></>
          ):(
            <Col className="d-flex flex-column">
              <small className="text-right">Vigência Fundos FY23: 01/07/2022 a 30/06/2023</small>
              <small className="text-right">Após o término da Campanha em 30 de Junho de 2023, os fundos</small>
              <small className="text-right">não resgatados serão expirados em 60 dias (20/08/2023) automaticamente.</small>
            </Col>
          )}
        </Row>
        <Row>
          <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 col-12">
            <Row className="mt-2 mb-2">
              <Col xs='12' md='10' className="text-left">
              {!!fiscal_year?(
              <></>
              ):( 
                <Can do="innovation.create" on="App">
                  {getDay() > 20 && getDay() <= 31 &&
                    getProfile() != 'Administrador' ? (<>
                    {profile.havePermission("action.add-out-period") ? (
                      <Link to="/elite/innovation/show">
                        <Button className="btn-add">
                          <Add /> Solicitar Resgate
                        </Button>
                      </Link>
                    ):(
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <Button
                          variant="light"
                          onClick={(e) => {
                            e.target.className = e.target.className.replace(
                              'btn-light',
                              'btn-reject btn-danger'
                            );
                            const parar = () => {
                              let element = document.getElementsByClassName(
                                'btn-reject'
                              )[0];
                              if (element)
                                element.className = element.className.replace(
                                  'btn-reject btn-danger',
                                  'btn-light'
                                );
                            };
                            window.setTimeout(parar, 500);
                          }}
                        >
                          <Add />
                          Solicitar Resgate
                        </Button>
                      </OverlayTrigger>
                      )}
                    </>) : (
                    <Link to="/elite/innovation/show">
                      <Button className="btn-add">
                        <Add /> Solicitar Resgate
                      </Button>
                    </Link>
                  )}
                </Can>
              )}
              </Col>
            </Row>
            <label className="w-100 text-right font-12" style={{ color: "red", fontWeight: 600 }}>
              *Após solicitação passar para o status de concluído, valor será transferido para o fundo ScanCash para ulitização
            </label>
            <Row>
              <Col xs="12">
                <NavBar addAll onChange={(key) => {
                  setFlowSelected(key)
                }}>
                  {status.map((item, k) => {
                    let quantity = countActions[item.id] ? countActions[item.id].amount : 0;
                    return (
                      <NavBar.Item
                        key={k}
                        eventKey={item.id}
                        title={item.name}
                        //title={item.id === 3 ? "Concluído" : item.name}
                        quantity={quantity}
                      />
                    )
                  })}
                </NavBar>
              </Col>
            </Row>
            <ActionList
              user={user}
              currentCompany={currentCompany}
              flowSelected={flowSelected}
              fiscalYear={fiscalYear}
            />
          </Card.Body>
        </Row>
      </Container>
    </>
  );
};
